import { Component, Inject, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { formatDate } from "@angular/common";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DatePipe } from '@angular/common';
import * as moment from 'moment';
import { AdministartionService } from 'src/app/service/administartion.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Constants } from 'src/app/constants';
import { Router } from '@angular/router';
import { RowNode } from 'ag-grid-community';
import { WarningDialogComponent } from '../warning-dialog/warning-dialog.component';
import { BookingInfoService } from 'src/app/service/export-parts/booking-info.service';
import { RefreshGridComponent } from '../../refresh-grid/refresh-grid.component';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-add-container-consolidation',
  templateUrl: './add-container-consolidation.component.html',
  styleUrls: ['./add-container-consolidation.component.scss']
})
export class AddContainerConsolidationComponent implements OnInit {
  playAudio: Subject<any> = new Subject();
  submitted = false
  isInvalid: boolean;
  errorMessage = '';
  heading!: string;
  isFindBookingInfoEnabled: boolean
  gridApi: any;
  columnDefs: any;
  displayRowData: any = [];
  defaultColDef: any;
  icons: any;
  rowCount: any;
  context: any;
  eventType: any = 'ADD';
  successMessage: any
  noRowsTemplate: string;
  gridOptions: any;
  constructor(
    private fb: FormBuilder, public dialog: MatDialog,
    public dialogRef: MatDialogRef<AddContainerConsolidationComponent>, @Inject(MAT_DIALOG_DATA) public dataStore: any,
    private ngxUiLoaderService: NgxUiLoaderService, private service: BookingInfoService,
    private constants: Constants,) {
  }
  addForm = this.fb.group({
    wayBillNumber: ['', [Validators.required]],
    renban: ['', [Validators.required]],
    containerNumber: ['', [Validators.required,Validators.maxLength(11),Validators.minLength(11),
      Validators.pattern(/^[a-zA-Z]{4}\d{7}$/)
    ]],
    vesselName: ['', [Validators.required]],
    cutOffDate: ['', [Validators.required]],
    etaDate: ['', [Validators.required]],
    // cutOffDate: formatDate(new Date(), "yyyy-MM-dd", "en"),
    // etaDate: formatDate(new Date(), "yyyy-MM-dd", "en"),
    serviceProvider: ['', [Validators.required]],
    voyageNumber: ['', [Validators.required]],
    sealNumber: ['', []],
    finalDest: ['', []],
    totalPallets: ['', [Validators.required,Validators.maxLength(5),Validators.pattern(/^(-1|[0-9]{1,5})$/),
    Validators.min(0),
    Validators.max(99999),]],
    L1GR: ['', [Validators.required,Validators.maxLength(5),Validators.pattern(/^(-1|[0-9]{1,5})$/),
    Validators.min(0),
    Validators.max(99999),]],
    L5: ['', [Validators.required,Validators.maxLength(5),Validators.pattern(/^(-1|[0-9]{1,5})$/),
    Validators.min(0),
    Validators.max(99999),]],
    L3: ['',[Validators.required,Validators.maxLength(5),Validators.pattern(/^(-1|[0-9]{1,5})$/),
    Validators.min(0),
    Validators.max(99999),]]
  })

  ngOnInit(): void {
    this.gridOptions = {
      suppressCellSelection: true
    };
    this.isFindBookingInfoEnabled = false
    this.eventType = this.dataStore.eventType
    if(this.eventType == 'ADD'){
    this.heading = 'Create Container';
      this.addForm.controls.wayBillNumber.disable();  this.addForm.controls.vesselName.disable();
      this.addForm.controls.cutOffDate.disable(); this.addForm.controls.serviceProvider.disable();
      this.addForm.controls.etaDate.disable(); 
      this.addForm.controls.voyageNumber.disable();
    
    }
    if(this.eventType == 'Edit'){
      this.heading = 'Edit Container';
      this.addForm.controls.wayBillNumber.disable();  this.addForm.controls.vesselName.disable();
      this.addForm.controls.cutOffDate.disable(); this.addForm.controls.serviceProvider.disable();
      this.addForm.controls.etaDate.disable(); this.addForm.controls.containerNumber.disable();
      this.addForm.controls.voyageNumber.disable();
    }
    if(this.eventType == 'Edit'){
      this.heading = 'Edit Container';
      console.log(this.dataStore.edit)
      let cutOffDate = moment(this.dataStore.edit.cutt_off_date).format( "YYYY-MM-DD");
      let etaDate = moment(this.dataStore.edit.eta).format( "YYYY-MM-DD");
      this.addForm.controls.wayBillNumber.disable();
      this.addForm.controls.cutOffDate.setValue(cutOffDate);
      this.addForm.controls.wayBillNumber.setValue(this.dataStore.edit.waybill);
      this.addForm.controls.serviceProvider.setValue(this.dataStore.edit.service_provider);
      this.addForm.controls.renban.setValue(this.dataStore.edit.renban);
      this.addForm.controls.containerNumber.setValue(this.dataStore.edit.container);
      this.addForm.controls.vesselName.setValue(this.dataStore.edit.vessel);
      this.addForm.controls.etaDate.setValue(etaDate);
      this.addForm.controls.voyageNumber.setValue(this.dataStore.edit.voyage_number);
      this.addForm.controls.sealNumber.setValue(this.dataStore.edit.seal_number);
      this.addForm.controls.finalDest.setValue(this.dataStore.edit.final_dest);
      this.addForm.controls.totalPallets.setValue(this.dataStore.edit.total_pallets);
      this.addForm.controls.L1GR.setValue(this.dataStore.edit.l1gr_modules);
      this.addForm.controls.L5.setValue(this.dataStore.edit.l5_modules);
      this.addForm.controls.L3.setValue(this.dataStore.edit.l3_modules);
    }
   
    this.noRowsTemplate =
      `<div class="noDataimg"><img src="./assets/images/noun_Empty_1735753.svg" style="width:41px"><br><span class="noDatamsg">No data available</span></div>`;
    this.columnDefs = [
      {
        headerName: '', field: '', filter: true, sortable: false, unSortIcon: false,width: 40,
        resizable: true, autoHeight: true, suppressHeaderFilterButton: true,
        floatingFilterComponent: RefreshGridComponent,
        floatingFilter: true, suppressMenu: true,
        headerCheckboxSelection: false,
        checkboxSelection: true,
        floatingFilterComponentParams: { suppressFilterButton: true, }
      },
      {
        headerName: "Waybill Number", autoHeight: true, suppressHeaderFilterButton: true, wrapText: true, autoWidth: true, field: "waybill",
        floatingFilterComponentParams: { suppressFilterButton: true }, floatingFilter: true, filter: 'agTextColumnFilter',
        unSortIcon: true, sortable: true,
      },
      {
        headerName: "Cut Off Date", autoHeight: true, suppressHeaderFilterButton: true, wrapText: true, autoWidth: true, field: "cuttoff_date",
        floatingFilterComponentParams: { suppressFilterButton: true }, floatingFilter: true, filter: 'agTextColumnFilter',
        unSortIcon: true, sortable: true,
      },
      {
        headerName: "Voyage", autoHeight: true, suppressHeaderFilterButton: true, wrapText: true, autoWidth: true, field: "voyage",
        floatingFilterComponentParams: { suppressFilterButton: true }, floatingFilter: true, filter: 'agTextColumnFilter',
        unSortIcon: true, sortable: true,
      },
      {
        headerName: "ETA", autoHeight: true, suppressHeaderFilterButton: true, wrapText: true, autoWidth: true, field: "eta",
        floatingFilterComponentParams: { suppressFilterButton: true }, floatingFilter: true, filter: 'agTextColumnFilter',
        unSortIcon: true, sortable: true,
      },
      {
        headerName: "Service Provider", autoHeight: true, suppressHeaderFilterButton: true, wrapText: true, autoWidth: true, field: "service_provider",
        floatingFilterComponentParams: { suppressFilterButton: true }, floatingFilter: true, filter: 'agTextColumnFilter',
        unSortIcon: true, sortable: true,
      }
    ]
    this.icons = {
      sortUnSort: '<img src="./assets/images/unsort.svg">',
    };


    this.getAllRenban()
  }
  bookingInfo: any = []
  getAllBookingInfoForContainer(){
    this.noRowsTemplate = `<div class="noDataimg"><img src="./assets/images/noun_Empty_1735753.svg" style="width:41px"><br><span class="noDatamsg">Loading... Please Wait</span></div>`;
    this.ngxUiLoaderService.start()
    this.service. getAllBookingInfoForContainer().subscribe(response => {
      this.ngxUiLoaderService.stop()
      if (response.allBookingInfo.length > 0) {

      this.displayRowData = response.allBookingInfo;
      }
      if (this.displayRowData.length == 0) {
        this.displayRowData = [];
        this.noRowsTemplate = `<div class="noDataimg"><img src="./assets/images/noun_Empty_1735753.svg" style="width:41px"><br><span class="noDatamsg">No data available</span></div>`;
      }
  //     console.log("---------Inseide Booking Info")
  //     this.noRowsTemplate = `<div class="noDataimg"><img src="./assets/images/noun_Empty_1735753.svg" style="width:41px"><br><span class="noDatamsg">No data available</span></div>`;
  //  //   this.displayRowData =  this.displayRowData.filter((it: any) => it.status == 'ACTIVE'); //Uncomment to get Active status of waybill Number
  //     }  
  })
  
  }

  renbanData: any = []
  getAllRenban() {
    this.ngxUiLoaderService.start()
    this.service.getAllRenban().subscribe(response => {
      this.ngxUiLoaderService.stop()
      this.renbanData = response.Renban.result;
      if(this.eventType == 'Edit'){
       // this.addForm.controls.renban.disable(); 
      }
     console.log("renban--->",this.renbanData);
    })
  }

  submitForm(status: any) {
    this.submitted = true
    console.log("=================",this.addForm);
    if (this.addForm.invalid) {
      return;
    }
    else {
      this.addContainerConsolidation(status);
    }
  }
  addContainerConsolidation(status: any) {
    let addUserObj = {

      "renban": this.addForm.controls.renban.value,
      "container": this.addForm.controls.containerNumber.value?.toUpperCase(),
      "cut": this.addForm.controls.cutOffDate.value,
      "waybill": this.addForm.controls.wayBillNumber.value,
      "eta": this.addForm.controls.etaDate.value,
      "vessel": this.addForm.controls.vesselName.value,
      "service": this.addForm.controls.serviceProvider.value,
      "voyage": this.addForm.controls.voyageNumber.value,
      "seal": this.addForm.controls.sealNumber.value,
      "final": this.addForm.controls.finalDest.value,
      "status": status,
      "total_pallets": this.addForm.controls.totalPallets.value,
      "l1gr_modules": this.addForm.controls.L1GR.value,
      "l5_modules": this.addForm.controls.L5.value,
      "l3_modules": this.addForm.controls.L3.value,
    }
    this.ngxUiLoaderService.start()
    if (this.eventType == 'ADD') {

      this.service.createContainer(addUserObj).subscribe({
        next: (res) => {
          this.ngxUiLoaderService.stop()
          try {
            if (res.status == "SUCCESS") {
              // this.successMessage = this.constants.APIDataSaved
              this.dialogRef.close(
                {
                  event: 'SaveEvent',
                  eventData: 'Data Saved Successfully.'
                }
              );
            }
            if (res.status == 'FAILURE') {
              this.dialogRef.close(
                {
                  event: 'SaveEvent',
                  status: res.status,
                  eventData: res.message
                }
              );
            }
          }
          catch (error) {
          }

        },
        error: (err: any) => {
          this.clearMsg();
          this.errorMessage = this.constants.APIErrorMessage
          this.showError(this.errorMessage);
          this.ngxUiLoaderService.stop()
        }
      })
    }
    let updateUserObj = {

      "renban": this.addForm.controls.renban.value,
      "container": this.addForm.controls.containerNumber.value?.toUpperCase(),
      "cut": this.addForm.controls.cutOffDate.value,
      "waybill": this.addForm.controls.wayBillNumber.value,
      "waybill1": this.dataStore.edit.waybill,
      "eta": this.addForm.controls.etaDate.value,
      "vessel": this.addForm.controls.vesselName.value,
      "service": this.addForm.controls.serviceProvider.value,
      "voyage": this.addForm.controls.voyageNumber.value,
      "seal": this.addForm.controls.sealNumber.value,
      "final": this.addForm.controls.finalDest.value,
      "status": status,
      "total_pallets": this.addForm.controls.totalPallets.value,
      "l1gr_modules": this.addForm.controls.L1GR.value,
      "l5_modules": this.addForm.controls.L5.value,
      "l3_modules": this.addForm.controls.L3.value,
    }
    if (this.eventType == 'Edit') {
      this.service.updateContainer(updateUserObj).subscribe({
        next: (res) => {
          this.ngxUiLoaderService.stop()
          try {
            if (res.status == "SUCCESS") {
              // this.successMessage = this.constants.APIDataUpdated
              this.dialogRef.close(
                {
                  event: 'UpdateEvent',
                  eventData: 'Data Updated Successfully.'
                }
              );
            }
            if (res.status == 'FAILURE') {
              this.clearMsg();
              this.errorMessage = this.constants.APIErrorMessage
              this.showError(this.errorMessage);
            }
          }
          catch (error) {
          }

        },
        error: (err: any) => {
          this.clearMsg();
          this.errorMessage = this.constants.APIErrorMessage
          this.showError(this.errorMessage);
          this.ngxUiLoaderService.stop()
        }
      })
    }
  }
  onClick() {
    this.dialogRef.close({
      event: 'Noevent'
    })
  }
  valSpecialChars1(stringIn: any) {
    let fieldValid = true;
    let splChars = "*|,\":<>[]{}`\';()@&$#%./!^_?\+-= ";
    for (let i = 0; i < stringIn.length; i++) {
      if (splChars.indexOf(stringIn.charAt(i)) != -1) { fieldValid = false; }
    }
    return fieldValid;
  }
  onPaste1(event: ClipboardEvent) {
    let clipboardData: any = event.clipboardData;
    let pastedText = clipboardData.getData('text');
    let test = this.valSpecialChars1(pastedText);
    if (!test) {
     event.preventDefault();
    }
  }
  validate(event: any) {
    return this.valSpecialChars(event.key)
  }

  validate1(event: KeyboardEvent) {
    console.log("event====>",event);
    let limit:any = this.addForm.controls.containerNumber.value?.length 
    console.log("limit======",limit)
    if(limit > 9)
    {
      event.preventDefault();
    }
    return this.valSpecialChars(event.key)
  }
  
  get f(): { [key: string]: AbstractControl } {
    return this.addForm.controls;
  }

  findBookingInfo() {
    this.isFindBookingInfoEnabled = true
    this.heading = 'Booking Information';

    this.addForm.controls.wayBillNumber.enable(); this.addForm.controls.finalDest.enable();
    this.addForm.controls.containerNumber.enable(); this.addForm.controls.vesselName.enable();
    this.addForm.controls.cutOffDate.enable(); this.addForm.controls.serviceProvider.enable();
    this.addForm.controls.etaDate.enable(); this.addForm.controls.sealNumber.enable();
    this.addForm.controls.voyageNumber.enable(); this.addForm.controls.totalPallets.enable();
    this.addForm.controls.L1GR.enable(); this.addForm.controls.L5.enable();this.addForm.controls.L3.enable();

    this. getAllBookingInfoForContainer()

  }
  selectedRowData = []
  addBookingInfo() {

    let currentDate = new Date();
    const selectedNodes = this.gridApi.getSelectedNodes();
    const selectedData = selectedNodes.map((node: RowNode) => node.data);
    this.selectedRowData = selectedData

    if (selectedData.length == 0) {
      this.clearMsg();
      this.errorMessage = 'Please select atleast one row'
      this.showError(this.errorMessage);
    }
    if (selectedData.length > 0) {
        this.errorMessage = '';
        this.isFindBookingInfoEnabled = false
        
      if(this.dataStore.flag1)
      {
        this.heading = 'Edit Container';
        this.addForm.controls.containerNumber.disable();
      }
      else
      {
        this.heading = 'Create Container';
      }
        let cutOffDate = moment(selectedData[0].cuttoff_date).format("YYYY-MM-DD");
        let etaDate = moment(selectedData[0].eta).format("YYYY-MM-DD");
        this.addForm.controls.wayBillNumber.setValue(selectedData[0].waybill);
        this.addForm.controls.serviceProvider.setValue(selectedData[0].service_provider);
        this.addForm.controls.cutOffDate.setValue(cutOffDate);
        this.addForm.controls.etaDate.setValue(etaDate);
        this.addForm.controls.vesselName.setValue(selectedData[0].vessel);
        this.addForm.controls.voyageNumber.setValue(selectedData[0].voyage);
        this.addForm.controls.vesselName.disable(); this.addForm.controls.voyageNumber.disable();
        this.addForm.controls.wayBillNumber.disable();
        this.addForm.controls.serviceProvider.disable();
        this.addForm.controls.cutOffDate.disable();
        this.addForm.controls.etaDate.disable();
        
     // }
    }
    console.log("---data store",this.dataStore);
  }

  defaultRowData() {
    this.displayRowData = [];
    this.gridApi?.setRowData(this.displayRowData)
    this.rowCount = this.displayRowData.length;
  }
  sizeToFit() {
    this.gridApi?.sizeColumnsToFit();
  }

  onGridReady(params: { api: any; }) {
    this.gridApi = params.api
    this.gridApi.sizeColumnsToFit();
  }
   //For Accepting only numbers or numeric
   numberValidate(event: any)
   {
     return this.acceptNumbers(event.key);
   }
   acceptNumbers(stringIn: any) {
     let fieldValid = true;
     let splChars = "*|,\":<>[]{}`';()@&$#%./!^_?+-= ";
     
     for (let i = 0; i < stringIn.length; i++) {
       if (splChars.indexOf(stringIn.charAt(i)) != -1) {
         fieldValid = false;
       }
     }
     if(stringIn.match(/^[a-zA-Z]+$/))
     {
       fieldValid = false;
     }
     return fieldValid;
   }
   onPaste2(event: ClipboardEvent) {
     let clipboardData: any = event.clipboardData;
     let pastedText = clipboardData.getData("text");
     let test = this.acceptNumbers(pastedText);
     if (!test) {
       event.preventDefault();
     }
   }
   routeVlidate(event: any) {
    return this.valSpecialChars(event.key);
  }
  valSpecialChars(stringIn: any) {
    let fieldValid = true;
    let splChars = "*|,\":<>[]{}`';()@&$#%./!^_?+-=";
    for (let i = 0; i < stringIn.length; i++) {
      if (splChars.indexOf(stringIn.charAt(i)) != -1) {
        fieldValid = false;
      }
    }
    return fieldValid;
  }
  clearMsg() {
    this.successMessage = "";
    this.errorMessage = "";
  }
  showError(msg: string) {
    this.playAudio.next('trouble');
    this.errorMessage = msg;
  }
  onPaste(event: ClipboardEvent) {
    let clipboardData: any = event.clipboardData;
    let pastedText = clipboardData.getData("text");
    let test = this.valSpecialChars(pastedText);
    if (!test) {
      event.preventDefault();
    }
  }

  enterData:any;

  checkDigit(event:any) 
  {
    //Generate the Check Digit for Container Number based on ISO 6346
    let enteredData = event.target.value.toUpperCase();
    if(!this.valSpecialChars(event.key) || (event.key === 'Enter'))
    {
      return 
    }

    if(enteredData.length > 3 && (!this.acceptNumbers(event.key)))
    {           
      return;
    }    

    if(enteredData.length != 9)
    {
      return 
    }

    enteredData = enteredData + event.key;
    const letterToNumber :any = {
      'A':10,'B':12,'C':13,'D':14,'E':15,'F':16,'G':17,'H':18,'I':19,'J':20,'K':21,'L':23,'M':24,'N':25,'O':26,
      'P':27,'Q':28,'R':29,'S':30,'T':31,'U':32,'V':34,'W':35,'X':36,'Y':37,'Z':38,'0':0,'1':1,'2':2,'3':3,'4':4,
      '5':5,'6':6,'7':7,'8':8,'9':9
    };
    const weights = [1,2,4,8,16,32,64,128,256,512];
    let letters = enteredData.slice(0,10);
    let digits = enteredData.slice(4,10);
    console.log("letter",letters,digits);
    // let sumLetter = 0;
    let i=0;
    let j=0;
    const   sumLetter = letters.split('').reduce((sum:any,letter:any)=>{
        let value = letterToNumber[letter]
        value = Number(value)*weights[i++];
        console.log("value",value,weights[j++]);
        return sum + value
      } , 0)
      
      //step 4
      let divSum = sumLetter/11;
      //step 5
      divSum = Math.floor(divSum);
      //stp 6
      let maxSum = divSum*11;
      //last step
      let final = maxSum-sumLetter;
      //Get the single digit
      final = Math.abs(final) % 10;
      if(!Number.isNaN(final))
      {
        this.enterData = enteredData+Math.abs(final);
        console.log("this.enterData",this.enterData);
        this.addForm.controls.containerNumber.setValue(this.enterData);
      }
  }
  
  checkDigitPaste(event:any) 
  {
    let clipboardData: any = event.clipboardData;
    let pastedText = clipboardData.getData('text');
    let test = this.valSpecialChars1(pastedText);
    if (!test) {
      return event.preventDefault();
    }

    //Generate the Check Digit for Container Number based on ISO 6346   
    if(pastedText.length !== 10)
    {
      return event.preventDefault(); 
    }

    let enteredData = pastedText;
    const letterToNumber :any = {
      'A':10,'B':12,'C':13,'D':14,'E':15,'F':16,'G':17,'H':18,'I':19,'J':20,'K':21,'L':23,'M':24,'N':25,'O':26,
      'P':27,'Q':28,'R':29,'S':30,'T':31,'U':32,'V':34,'W':35,'X':36,'Y':37,'Z':38,'0':0,'1':1,'2':2,'3':3,'4':4,
      '5':5,'6':6,'7':7,'8':8,'9':9
    };
    const weights = [1,2,4,8,16,32,64,128,256,512];
    let letters = enteredData.slice(0,10);
    let digits = enteredData.slice(4,10);
    console.log("letter",letters,digits);
    // let sumLetter = 0;
    let i=0;
    let j=0;
    const   sumLetter = letters.split('').reduce((sum:any,letter:any)=>{
        let value = letterToNumber[letter]
        value = Number(value)*weights[i++];
        console.log("value",value,weights[j++]);
        return sum + value
      } , 0)
      
      //step 4
      let divSum = sumLetter/11;
      //step 5
      divSum = Math.floor(divSum);
      //stp 6
      let maxSum = divSum*11;
      //last step
      let final = maxSum-sumLetter;
      //Get the single digit
      final = Math.abs(final) % 10;

      if(!Number.isNaN(final))
      {
        event.preventDefault();
        this.enterData = enteredData+Math.abs(final);
        console.log("this.enterData",this.enterData); 
        this.addForm.controls.containerNumber.setValue(this.enterData);
      }
  }
 
}
